import React, { useEffect } from "react";
import "../../css/components/controls/HrnbModal.css";

export default function HrnbModal({
                                      open,
                                      onClose,
                                      title,
                                      children,
                                      className = "",
                                      style = {},
                                      closeOnOverlay = true,
                                      ...props
                                  }) {
    useEffect(() => {
        if (!open) return;
        const onEsc = (e) => {
            if (e.key === "Escape") onClose && onClose();
        };
        window.addEventListener("keydown", onEsc);
        return () => window.removeEventListener("keydown", onEsc);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="hrnb-modal-overlay" onClick={closeOnOverlay ? onClose : undefined}>
            <div
                className={`hrnb-modal ${className}`}
                style={style}
                onClick={e => e.stopPropagation()}
                {...props}
            >
                <button className="hrnb-modal-close" onClick={onClose} aria-label="Закрыть" tabIndex={0}>
                    ×
                </button>
                {title && <div className="hrnb-modal-title">{title}</div>}
                <div className="hrnb-modal-content">{children}</div>
            </div>
        </div>
    );
}
